import { Provider } from '@angular/core';

import { ReaderConfigStore } from './reader-config.store';
import { ReaderStore } from './reader.store';

export const READER_STORE_PROVIDERS: Provider[] = [ReaderStore, ReaderConfigStore];
